import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { DataModuloMain } from "../ModuloMain";
import { DataUtil } from "../util/Util";

import { MGrupo } from "../model/MGrupo";
import { _DICC_GRUPO } from "./Grupo";
import { MEscolaridad } from "../model/MEscolaridad";
import { IEscolaridad } from "../entidad/Escolaridad";
import { MGrado } from "../model/MGrado";
import { MEscuela } from "../model/MEscuela";

const RequestID = Entidad.CTipoRequest.Escolaridad;
export const _DICC_ESCOLARIDAD: Map<number, MEscolaridad> = new Map();
/** Map<idEscolaridad, Map<idGrado, Grado(Nivel)>> */
export const _DICC_ASIGNACION_ESCOLARIDAD_GRADOS: Map<number, Map<number, MGrado>> = new Map();

export async function _SvEscolaridadObtenerLista(escuelas: Array<MEscuela>): Promise<DataDRequest.IRequestResponseListA<IEscolaridad>[]> {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/ObtenerLista";
    const results = new Array<DataDRequest.IRequestResponseListA<IEscolaridad>>();

    for await (let escuela of escuelas) {
        const rowID = escuela.IdKinder
        const currentDateStr = await DataUtil._GetMaxDate(RequestID, rowID);
        const params = {
            "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
            "IdEscuela": rowID,
            "Modificacion": currentDateStr
        }

        let result = await DataDRequest._Request4List(url, "GET", params, RequestID, rowID);

        results.push(result);
    }
    return results;
}

export function _SvEscolaridadNueva(idEscuela: number, nombreNivel: string, grados: Array<string>): Promise<DataDRequest.IRequestResponseA> {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/NuevaEscolaridad";
    const params = {
        IdOrganizacion: DataUtil._Usuario.IdOrganizacion,
        IdUsuario: DataUtil._Usuario.IdUsuario,
        IdEscuela: idEscuela,
        Nombre: nombreNivel,
        Grados: grados
    }
    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Escolaridad);
}

export async function _SvEscolaridadObtenerConfiguracion(idEscolaridad: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/ObtenerConfiguracion";
    const params = {
        IdEscolaridad: idEscolaridad,
        Modificacion: null
    }
    const res = await DataDRequest._Request5<Entidad.IConfigEscolaridad>(url, "GET", params);

    if (res.Resultado > 0 && res.Datos?.Actividades) {
        for (let k in res.Datos.Actividades) {
            let item = res.Datos.Actividades[k];
            switch (item.Tipo) {
                case Entidad.CTipoEvento.Chat:
                    item.Configuracion = [
                        Number((item.Configuracion || [1])[0]) as Entidad.CTipoChat
                    ];
                    break;
                case Entidad.CTipoEvento.Alimentos:
                    if (!item.ConfiguracionSecundaria) {
                        item.ConfiguracionSecundaria = [false, false];
                    }
                    item.ConfiguracionSecundaria[0] = item.ConfiguracionSecundaria[0] + "" == "true" ? true : false;
                    item.ConfiguracionSecundaria[1] = item.ConfiguracionSecundaria[1] + "" == "true" ? true : false;
                    break;
                case Entidad.CTipoEvento.Covid:
                    item.Configuracion = [
                        Number((item.Configuracion || [0])[0]) as 0 | 1
                    ]
                    break;
            }
        }
    }

    return res;
}

export interface IConfiguraEscolaridadResponse {
    Actualizados: Array<number>;
    Eliminados: Array<number>;
    Nuevos: Array<number>;
}
type IEventoEscolaridadItem = Entidad.IEventoEscolaridadItem<Entidad.CTipoEvento>;
type IEventoEscolaridadItemReq = Omit<IEventoEscolaridadItem, keyof Pick<IEventoEscolaridadItem, "EnUso">>;
export interface IConfiguraEscolaridadParams {
    Actividades: Array<IEventoEscolaridadItemReq>,
    ActividadesEliminar: Array<number>,
    CobroTiempo: Array<number>,
    CobroCosto: Array<number>,
    CobroTolerancia: Array<number>
    NivelSAT: string | undefined
    AutRVOE: string | undefined
}
export function _SvEscolaridadConfigurar(idEscolaridad: number, params: IConfiguraEscolaridadParams): Promise<DataDRequest.IRequestResponseA<IConfiguraEscolaridadResponse>> {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/ConfigurarEscolaridad";
    const finalParams: IConfiguraEscolaridadParams & { IdUsuario: number, IdEscolaridad: number } = {
        IdUsuario: DataUtil._Usuario.IdUsuario,
        IdEscolaridad: idEscolaridad,
        Actividades: params.Actividades,
        ActividadesEliminar: params.ActividadesEliminar,
        CobroTiempo: params.CobroTiempo,
        CobroCosto: params.CobroCosto,
        CobroTolerancia: params.CobroTolerancia,
        NivelSAT: params.NivelSAT?.trim() || undefined,
        AutRVOE: params.AutRVOE?.trim() || undefined
    }
    return DataDRequest._Request5<IConfiguraEscolaridadResponse>(url, "POST", finalParams, Entidad.CTipoRequest.Escolaridad);
}

interface IEditarEscolaridadResponse {
    Actualizados: number[];
    Eliminados: number[];
    Nuevos: number[];
}
interface IItemGrado {
    /** Los grados a actualizar requieren Id */
    Id?: number;
    Nombre: string;
}
export function _SvEscolaridadActualizar(idEscolaridad: number, nombreEscolaridad: string, grados: IItemGrado[], gradosEliminar: number[]): Promise<DataDRequest.IRequestResponseA<IEditarEscolaridadResponse>> {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/ActualizarEscolaridad";
    const params = {
        "IdEscolaridad": idEscolaridad,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Nombre": nombreEscolaridad,
        "Grados": grados,
        "GradosEliminar": gradosEliminar
    }
    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Escolaridad);
}

export async function _SvEscolaridadEliminar(idEscolaridad: number): Promise<DataDRequest.IRequestResponseA> {
    const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/EliminarEscolaridad";
    const params = {
        "IdEscolaridad": idEscolaridad,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Escolaridad);
}

// /** Resultado
//  * * (> 0) - Exitoso
//  * * (-1) - Escolaridad no encontrada
//  * * (-2) - No tiene configuración para tipos de alimento
//  * * (-3) - Calendario no configurado (no vinculado)
//  */
// export async function _AsignarCalendarioGoogle(idEscolaridad: number): Promise<DataDRequest.IRequestResponseA> {
//     const url = _APP_CONFIG.URL_RSTV2 + "escolaridad/AsignarCalendariosAlimento";
//     const params = {
//         "IdUsuario": DataUtil._Usuario.IdUsuario,
//         "IdEscolaridad": idEscolaridad
//     }
//     return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Escolaridad);
// }

// *************************************************************
// LOCAL DATA
// *************************************************************

/**
 * @param idEscolaridad
 * @returns Map()
 */
export function _LOCALDATA_GetGradosDeEscolaridad(idEscolaridad: number): Map<number, MGrado> {
    return (_DICC_ASIGNACION_ESCOLARIDAD_GRADOS.get(idEscolaridad) || new Map());
}

/**
* @param idEscolaridad
* @returns Array()
*/
export function _LOCALDATA_GetGruposEnEscolaridad(idEscolaridad: number): Array<MGrupo> {
    return Array.from(_DICC_GRUPO.values())
        .filter(d => (d.IdEscolaridad == idEscolaridad));
}

/**
 * @param idEscolaridad
 * @returns Array()
 */
export function _LOCALDATA_GetAlumnosEnEscolaridad(idEscolaridad: number): Array<Entidad.IAlumno> {
    return DataModuloMain._GetReqDataArrayByName("Alumno")
        .filter(d => (d.IdEscolaridad == idEscolaridad));
}
